<div *ngIf="isLoggedIn">
	<header [title]="title" (reloadPage)="reloadPage()"></header>

	<nav *ngIf="showNav" [class]="layoutCssClass" [ngClass]="{ 'no-footer': !showFooter }" [expand]="expand" (setLayoutClass)="setLayoutClass()" (reloadPage)="reloadPage()"></nav>

	<nav-right *ngIf="showNav && showRightNav" [ngClass]="{ 'no-footer': !showFooter, 'expand-right': expandRight }" [expandRight]="expandRight" (setLayoutClassRight)="setLayoutClassRight()" (reloadPage)="reloadPage()"></nav-right>

	<content [class]="layoutCssClass" [ngClass]="{ 'no-nav': !showNav, 'no-footer': !showFooter, 'expand-right': showRightNav && expandRight, 'no-right-nav': !showRightNav }">
		<router-outlet></router-outlet>
	</content>

	<footer *ngIf="showFooter"></footer>
</div>

<div *ngIf="modal" class="modal-window">
	<div class="locked"></div>
	<ng-container [ngComponentOutlet]="modal.type" [ndcDynamicInputs]="modal.inputs" [ndcDynamicOutputs]="modal.outputs"></ng-container>
</div>

<div *ngIf="!isLoggedIn && layoutCssClass !== 'noaccess'">
    <div class="auth">Authenticating...</div>
</div>

<access *ngIf="layoutCssClass === 'noaccess'"></access>
<error *ngIf="error !== ''" [message]="error"></error>

<div *ngIf="showAlert" class="modal-window">
	<div class="locked"></div>
	<alert
		[title]="alertTitle"
		[message]="alertMessage"
		[continueText]="alertContinueText"
		[cancelText]="alertCancelText"
		(continueEvent)="alertContinue()"
		(cancelEvent)="alertCancel()"></alert>
</div>

<div *ngIf="showNotificationBlocker" class="notification-blocker"></div>

<sdk-loading [isLoading]="isLoading"></sdk-loading>
